import React from "react";
import { useFormContext } from "react-hook-form";
import { Row, Col } from "react-bootstrap";
import { TextInput } from "ui";

export const AuthenticationForm = () => {
  const { register } = useFormContext();
  return (
    <div className="custom-box">
      <Row>
        <h1 className="my-4">فرم اهراز هویت مشخصات شخصی </h1>
      </Row>

      <Row>
        <Col md={3} sm={6}>
          <TextInput
            registration={register("nationalId")}
            placeholder={"کد ملی خود را وارد کنید"}
            label={"کد ملی"}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3} sm={6}>
          <TextInput
            registration={register("birthday")}
            placeholder={"تاریخ تولد خود را وارد کنید"}
            label={"تاریخ تولد"}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3} sm={6}>
          <TextInput
            registration={register("backCardNumber")}
            placeholder={"شماره کارت بانکی خود را وارد کنید"}
            label={"شماره کارت بانکی"}
          />
        </Col>
      </Row>
    </div>
  );
};
